
import { useNavigate } from 'react-router-dom'
import './MHome.scss'
import { MobileUserInfoLabel } from '@/components/User'
import { ActivityInfoModel, QuestionnaireModel } from '@/models/typing'
import StarRating from '@/components/Star'
import { defaultQuizState, fetchActivityInfoState, fetchQuestionListState, quizState, userSelectedIdsState } from '@/models/quizState'
import { useRecoilCallback, useRecoilRefresher_UNSTABLE, useRecoilState, useRecoilValue, useRecoilValueLoadable, useSetRecoilState } from 'recoil'
import ErrorPage from '@/components/Error'
import { DefaultLoadingPage } from '@/components/Loading'
import { useEffect } from 'react'
import { activityInfoState } from '@/App'
import { Toast } from 'antd-mobile'
import { CError } from '@/utils/server'
import { QuizAlert } from '@/components/Alert'
import { isMobile } from '@/utils/util'
import { Tracking } from '@/utils/tracking'

type HomePageProps = {
    list: QuestionnaireModel[]
}


export const HomePageItemComponent = ({ item }: { item: QuestionnaireModel }) => {

    const navigate = useNavigate()

    const [quiz, setQuiz] = useRecoilState(quizState)

    const setUserSelectedIds = useSetRecoilState(userSelectedIdsState)


    const fetchQuestionList = useRecoilCallback(({ snapshot }) => async (item :QuestionnaireModel) => {
        try {
            const result = await snapshot.getPromise(fetchQuestionListState({'questionnaire_id':item.questionnaire_id,'__':`${Math.random()}`}))
            setQuiz({
                ...defaultQuizState,
                questionList: result,
                questionnaire: item,
            })
            setUserSelectedIds({})
            navigate('/quiz')
        } catch (error ) {
            const err = error as CError
            Toast.show({content: err.message})
        }
    })

    return (
        <div className={isMobile() ? 'mobile-questionnaire-item': 'desktop-questionnaire-item'}  onClick={() => {
            Tracking.UP('click_all_answer_QuestionBank_button', '', { 'title': item.title })
            if (item.times == 0) {
                fetchQuestionList(item)
            } else {
                setQuiz({
                    ...defaultQuizState,
                    questionnaire: item,
                    alertType : item.times > item.cur_times ? 'start' : 'sorry',
                    alert: true,
                })
            }
        }} >
            <div className='board'></div>
            <img className='image' src={item.img} />
            <div className='quality'>
                <p className='title'>{item.title}</p>
                <div className='info'>
                    <p >难易程度:</p>
                    <StarRating rating={item.degree} />
                </div>
            </div>
            {
                item.times > 0 && (
                    <div className='times'>
                        <p className='title'>{`本日挑战内容: ${item.remark}`}</p>
                        <p className='number'>{`本日剩余次数: ${(item.times - item.cur_times)}/${item.times}次`}</p>
                    </div>
                )
            }
        </div>
    )

}


const HomePage = ({ list }: HomePageProps) => {

    const navigate = useNavigate()

    const quiz = useRecoilValue(quizState)
    
    return (
        <div className="mobile-container">
            <div className='home-head'>
                <div className='tools'>
                    <a className='leftbtn' onClick={() => {
                        navigate('/guide')
                    }}></a>
                    <a className='rightbtn' onClick={() => {
                        navigate(`/honors/${Math.random()}`)
                        Tracking.UP('click_all_answer_glory_button')
                    }}></a>
                </div>
                <div className='title'></div>
                <MobileUserInfoLabel />
            </div>
            <ul className='home-body'>
                {
                    list.map((item, index) => (
                        (
                            <HomePageItemComponent item={item} key={index} />
                        )
                    ))
                }
                <div style={{ height: '0.6rem' }}></div>
            </ul>
            {quiz.alert && <QuizAlert />}
        </div>
    )
}



export const MobileHome = () => {

    const [activityInfo, setActivityInfo] = useRecoilState(activityInfoState)

    const { state, contents } = useRecoilValueLoadable<ActivityInfoModel>(fetchActivityInfoState)

    const refresh = useRecoilRefresher_UNSTABLE(fetchActivityInfoState)


    useEffect(() => {
        if (state === 'hasValue') {
            setActivityInfo(contents)
        }
    }, [state])


    switch (state) {
        case 'hasValue':
            return <HomePage list={activityInfo.questionnaire_list} />
        case 'hasError':
            return <ErrorPage message={contents.message} onRetry={() => { refresh() }} />; 
        case 'loading':
            return <DefaultLoadingPage />;
    }

}

